import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import * as Constants from '../../common/constants';

interface IProps {
  classes: any
}

interface IState {
  value: number
}

class ScrollableTabsButtonAuto extends React.Component<IProps, IState> {
  state = {
    value: 0,
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChangeIndex = index => {
    this.setState({ value: index });
  };

  render() {
    const { classes } = this.props;
    const { value } = this.state;

    return (
      <div style={{ padding: "20px" }}>
        <div style={{ margin: '10px 0' }}>
          Name
        </div>
        {/* <AppBar position="static" color="default"> */}
        <Tabs
          value={value}
          onChange={this.handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
          classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
        >
          <Tab label="Item One" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Two" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Three" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Four" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Five" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Six" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
          <Tab label="Item Seven" classes={{ root: classes.tabRoot, selected: classes.tabSelected }} />
        </Tabs>
        {/* </AppBar> */}
        <div>
          <SwipeableViews
            axis={'x'}
            index={this.state.value}
            onChangeIndex={this.handleChangeIndex}
          >
            <div>Item One</div>
            <div>Item Two</div>
            <div>Item Three</div>
            <div>Item Four</div>
            <div>Item Five</div>
            <div>Item Six</div>
            <div>Item Seven</div>
            {/* {value === 0 && <div>Item One</div>}
            {value === 1 && <div>Item Two</div>}
            {value === 2 && <div>Item Three</div>}
            {value === 3 && <div>Item Four</div>}
            {value === 4 && <div>Item Five</div>}
            {value === 5 && <div>Item Six</div>}
            {value === 6 && <div>Item Seven</div>} */}
          </SwipeableViews>
        </div>
      </div>
    );
  }
}


export default withStyles(Constants.TabStyles)(ScrollableTabsButtonAuto);